import React, { FC, useCallback, useMemo } from 'react';
import { DatePicker } from 'antd';
import moment from 'moment';
import { Constants } from '@core/constants';

const { RangePicker } = DatePicker;

export const DateFilter: FC<any> = ({ column: { filterValue, setFilter } }) => {
  const value = useMemo(() => {
    if (filterValue) {
      return filterValue.split(',').map((date) => moment(date, Constants.DATE_TIME));
    }
  }, [filterValue]);

  const handleChange = useCallback(
    (value) => {
      if (value instanceof Array) {
        setFilter(value.map((date) => moment(date, Constants.DATE_TIME).format(Constants.DATE_TIME)).join(','));
      } else {
        setFilter(undefined);
      }
    },
    [setFilter],
  );

  return <RangePicker showTime={true} onChange={handleChange} value={value} format={Constants.DATE_TIME} />;
};
